import { render, staticRenderFns } from "./TeaserRcWrapper.vue?vue&type=template&id=d2211822"
import script from "./TeaserRcWrapper.vue?vue&type=script&lang=ts"
export * from "./TeaserRcWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TeaserRcWrapper.vue?vue&type=style&index=0&id=d2211822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports